module.exports = __webpack_public_path__ + "img/download 2.e137f503.svg";